import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import styles from "standard.module.scss";
import coffeeIcon from "assets/images/categories/coffee-light.svg";
import personalCareIcon from "assets/images/categories/drop-simple-light.svg";
import smokingIcon from "assets/images/categories/cigarette-light.svg";
import otherIcon from "assets/images/categories/question-light.svg";

import { LitterFunction, LITTER_FUNCTION_META } from "custom/litterFunctions";

const useStyles = makeStyles((theme) => ({
  card: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(1),
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: "#fff",
    cursor: "pointer",
    transition: "box-shadow 0.2s",
    boxShadow: styles.boxShadowSoftElevation
  },
  icon: {
    width: 38,
    height: 38,
    marginBottom: theme.spacing(0.8)
  },
  label: {
    fontSize: "1rem",
    fontWeight: 400,
    textAlign: "center"
  }
}));

type Props = {
  fn: LitterFunction;
  onClick: () => void;
};

const ICONS: Record<LitterFunction, string> = {
  [LitterFunction.FOOD_DRINK]: coffeeIcon,
  [LitterFunction.PERSONAL_CARE]: personalCareIcon,
  [LitterFunction.SMOKING]: smokingIcon,
  [LitterFunction.OTHER]: otherIcon
};

export default function FunctionCard({ fn, onClick }: Props) {
  const classes = useStyles();
  const meta = LITTER_FUNCTION_META[fn];
  const iconSrc = ICONS[fn] || ICONS[LitterFunction.OTHER];

  return (
    <div className={classes.card} onClick={onClick}>
      <img src={iconSrc} alt={meta.label} className={classes.icon} />
      <Typography className={classes.label}>{meta.label}</Typography>
    </div>
  );
}
